import * as d3 from 'd3'
import ScenarioService from "@/services/scenario.service";

const { NodeType } = ScenarioService

export const wrap = (text, width) => {
    text.each(function () {
        let spanList = []
        let text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1, // ems
            x = 0,
            y = text.attr("y"),
            dx = parseFloat(text.attr("dx")),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dx", dx)
                .attr("dy", dy + "em");
        spanList.push(tspan)
        while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
                line.pop();
                tspan.text(line.join(" "));
                line = [word];
                tspan = text.append("tspan")
                    .attr("x", x)
                    .attr("y", y)
                    .attr("dx", dx)
                    .attr("dy", ++lineNumber * lineHeight + dy + 0.5 + "em")
                    .text(word);
                spanList.push(tspan)
            }
        }
        for (let tspan of spanList) {
            tspan.attr("y", -lineNumber / 2 + 'em')
        }
    });
}

export const limitLength = (str, max) => {
    if (str.length > max) {
        return str.substring(0, max - 3) + '...'
    }
    return str
}

export const getShape = (d, layoutConfig, PortalSourceMap) => {
    let type = d.data.type
    if (type === NodeType.PORTAL) {
        type = PortalSourceMap[d.id].type
    }
    let width = 0
    let height = 0
    let radius = 0
    switch (type) {
        case NodeType.SUPPORTER:
            width = layoutConfig.supporterWidth ? layoutConfig.supporterWidth : layoutConfig.nodeWidth
            height = layoutConfig.supporterHeight ? layoutConfig.supporterHeight : layoutConfig.nodeHeight
            radius = layoutConfig.supporterRadius ? layoutConfig.supporterRadius : layoutConfig.nodeRadius
            break
        case NodeType.PROCESS:
            width = layoutConfig.processWidth ? layoutConfig.processWidth : layoutConfig.nodeWidth
            height = layoutConfig.processHeight ? layoutConfig.processHeight : layoutConfig.nodeHeight
            radius = layoutConfig.processRadius ? layoutConfig.processRadius : layoutConfig.nodeRadius
            break
        case NodeType.DECISION:
            width = layoutConfig.decisionWidth ? layoutConfig.decisionWidth : layoutConfig.nodeWidth
            height = layoutConfig.decisionHeight ? layoutConfig.decisionHeight : layoutConfig.nodeHeight
            radius = layoutConfig.decisionRadius ? layoutConfig.decisionRadius : layoutConfig.nodeRadius
            break
        default:
            width = layoutConfig.nodeWidth
            height = layoutConfig.nodeHeight
            radius = layoutConfig.nodeRadius
    }
    return { width, height, radius, rx: width / 2, ry: height / 2, }
}

export default { wrap, limitLength, getShape }
